"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBox = exports.StyledCloseButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const box_1 = require("../box");
const types_1 = require("./types");
exports.StyledCloseButton = styled_components_1.default.button `
  float: right;
  cursor: pointer;
  border: none;
  background-color: transparent;
  padding: ${(props) => props.padding};

  color: ${(props) => props.color};
  margin: ${(props) => props.margin};

  &:hover {
    ${(props) => props.hoverEffect !== types_1.CloseButtonHoverProps.None && `filter: brightness(${props.hoverEffect})`};
  }

  &:after {
    content: '✕';
    font-size: ${(props) => props.size};
    line-height: ${(props) => props.size};
    padding: 0 5px;
  }

  &:focus {
    background-color: transparent;
    border-color: #e77600;
    box-shadow: 0 0 3px 2px rgba(228, 121, 17, 0.5);
    outline: 0;
  }
`;
exports.StyledBox = (0, styled_components_1.default)(box_1.Box) `
  width: 100px;
  height: 100px;
  border: 1px solid black;
  position: relative;
`;
